// Errors in the app reach us as they happen (Sentry), not only in someone's
// browser console. Switched on at build time by VITE_SENTRY_DSN, which Render
// passes into the Docker build; without it nothing is loaded or sent. Sentry's
// code is loaded on demand, so the app's own bundle doesn't grow.
//
// What's sent: the error, the page's address, the clicks and requests just
// before it, and the signed-in person's Clerk id. Never their email or IP
// address.

type SentryModule = typeof import("@sentry/react");

let sentry: Promise<SentryModule> | null = null;

export function startAlerts(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn || sentry) return;
  sentry = import("@sentry/react").then((S) => {
    S.init({
      dsn,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
      release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
      sendDefaultPii: false,
    });
    return S;
  });
}

export function alertsOn(): boolean {
  return sentry !== null;
}

/** Report an error the app caught and handled itself (a card that failed to
 * draw), which Sentry would otherwise never see. */
export function reportError(error: unknown, tags?: Record<string, string>): void {
  void sentry?.then((S) => S.captureException(error, tags ? { tags } : undefined));
}

/** Who was signed in, by Clerk id only. */
export function identify(userId: string | null | undefined): void {
  void sentry?.then((S) => S.setUser(userId ? { id: userId } : null));
}
